import axios from "axios";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_FLEX_GATEWAY_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let phoenixToken: string | null = null;

export const setPhoenixToken = (token: string | null) => {
  phoenixToken = token;
};

export const getPhoenixToken = () => phoenixToken;

apiClient.interceptors.request.use(
  (config) => {
    if (phoenixToken) {
      config.headers.phoenixToken = phoenixToken;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
